import styled from 'styled-components';

import { MYAGIREP } from '../../constants';

export const ContainerOverride = styled.div`
  &.ui.container.override main {
    ${({ page }) => {
      if (page === MYAGIREP) {
        return `
        @media only screen and (min-width: 768px) {
          min-height: auto !important;
          /*padding-bottom: 0 !important; */
        }
      `;
      }
    }}
  }
`;
